export default function PageHero({ eyebrow, title, accent, subhead, children }) {
  return (
    <section className="m61-grid-bg border-b border-m61-line overflow-hidden" data-testid="page-hero">
      <div className="m61-container py-20 lg:py-28">
        <div className="max-w-3xl m61-fade-up">
          {eyebrow && <p className="m61-eyebrow mb-8">{eyebrow}</p>}
          <h1 className="m61-h1 mb-8">
            {title} {accent && <span className="m61-gradient-text">{accent}</span>}
          </h1>
          {subhead && <p className="m61-lead max-w-2xl">{subhead}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
